import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useDebouncedCallback } from 'use-debounce'
import { sortListWithEntityType } from '../libraries/entityTools'
import { sanitiseFilterString } from '../libraries/sanitiseFilterString'
import entityActions, { getReduxKey } from '../store/entity/actions'
import { defaultQueryParams } from '../screens/EntityListScreen'

export const useLoadTableData = ({ entityType, route, per_page = 48 }) => {
  const dispatch = useDispatch()
  const [filter, updateFilter] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const debouncedUpdateFilter = useDebouncedCallback(updateFilter, 500)
  const [queryParams, setQueryParams] = useState(defaultQueryParams)

  const reduxKey = sanitiseFilterString(getReduxKey(filter, { detailed: true }))

  const path = `${entityType?.name + reduxKey}`
  const entityListWrapper = useSelector((state) => {
    const entityListWrapper = entityType
      ? state.entities[path] ?? {
          data: null,
          meta: null,
          hasSeenData: false
        }
      : { data: null, meta: null, hasSeenData: false }

    entityListWrapper.data = sortListWithEntityType(
      entityListWrapper.data,
      entityType
    )
    return entityListWrapper
  })

  const { page = null, searchText, due_at } = queryParams

  const fetchItemsForParams = () => {
    const from_widget = route?.params?.from_widget
    setIsLoading(true)
    return dispatch(
      entityActions.listEntity(entityType, {
        filter,
        page,
        searchText,
        due_at,
        per_page,
        from_widget,
        isFullRefresh: page == 1,
        detailed: true
      })
    ).then(() => {
      setIsLoading(false)
    })
  }

  const fetchAnotherPage = () => {
    const { page = null } = queryParams

    const maxPages = entityListWrapper.meta?.last_page

    if (page < maxPages) {
      setQueryParams({ ...queryParams, page: page + 1 })
    }
  }

  useEffect(() => {
    fetchItemsForParams()
  }, [queryParams, filter])

  const { data, meta } = entityListWrapper
  return {
    data,
    meta,
    isLoading,
    fetchItemsForParams,
    fetchAnotherPage,
    queryParams,
    setQueryParams,
    updateFilter: debouncedUpdateFilter
  }
}
